module.exports = __webpack_public_path__ + "static/img/zhiHuiNongCHang_details.a06ee234.jpg";